import * as React from 'react';
import { get, map } from 'lodash';
import { TAppointment } from 'ui-model';
import AppointmentsListContainer from '../AppointmentsListContainer';
import AppointmentItem from '../AppointmentItem';

interface IAppointmentsListData {
  data: TAppointment[];
  isRescheduleEnabled: boolean;
}

const AppointmentsListData = (props: IAppointmentsListData) => {
  const { isRescheduleEnabled, data } = props;
  const [selectedAppointment, setSelectedAppointment] = React.useState<TAppointment>(data[0]);

  return (
    <AppointmentsListContainer>
      {map(data, (appointment) => {
        const isAppointmentSelected = appointment._id === get(selectedAppointment, '_id');

        return (
          <AppointmentItem.Container
            id={appointment._id}
            isAppointmentSelected={isAppointmentSelected}
            isRescheduleEnabled={isRescheduleEnabled}
            onClick={() => setSelectedAppointment(appointment)}
          >
            <AppointmentItem.Header
              appointmentDate={appointment.date}
              appointmentTypeName={appointment.type.name || '...'}
              isAppointmentSelected={isAppointmentSelected}
            />
            <AppointmentItem.Collapsable isAppointmentSelected={isAppointmentSelected}>
              <AppointmentItem.Divider />
              <AppointmentItem.Content appointment={appointment} />
              <AppointmentItem.ActionButtons appointment={appointment} isRescheduleEnabled={isRescheduleEnabled} />
            </AppointmentItem.Collapsable>
          </AppointmentItem.Container>
        );
      })}
    </AppointmentsListContainer>
  );
};

export default AppointmentsListData;
